import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import GridTooltip from '../../portal/gridTooltip';
import { Link } from 'react-router-dom'; 

@inject('rolesStore', 'translationsStore','oidcStore') @observer
export default class RolesTooltipContainer extends Component {

    IsUserAllowedToAccessRoles = () => {
        const userPermissions = this.props.oidcStore.currentUser.profile['access-control-permissions'];
        const allowedPermission = 'manage-roles';

        if(!userPermissions) 
            return false;
        
        if(typeof userPermissions === 'string') 
            return userPermissions === allowedPermission;
        
        return userPermissions.includes(allowedPermission);    
    }

    getSingleRoleItem = item => this.IsUserAllowedToAccessRoles() ? <Link to={`/roles/${item.id}/`}> {item.name} </Link> : item.name;

    getRoles = () => {
        let roles = [];

        this.props.roleIds.forEach(id => {
            
            this.props.rolesStore.roles.forEach(role => {
                
                if (role.id === id) {
                    
                    roles.push(role);
                }
            });
        });

        return roles;
    }

    render() {

        let roles = this.getRoles();
        
        if (roles.length > 1) {
            
            let sortedRolesList = roles.sort((a,b) => a - b);

            return <GridTooltip
                        translations={{title: this.props.translationsStore.translate('ROLES')}}
                        count={this.props.roleIds.length}
                        defaultName={sortedRolesList[0].name}
                        itemId={this.props.itemId}
                        items={roles}
                        isRolesTooltip
                        IsUserAllowedToAccessRoles={this.IsUserAllowedToAccessRoles()}
                    />;
        }
        else if (roles.length === 1) {

            return <span className='ellipsis' title={roles[0].name}>
                        {this.getSingleRoleItem(roles[0])}
                    </span>;
        }
        return null;
    }
}